import { render, staticRenderFns } from "./ManageUserGroupsTable.vue?vue&type=template&id=f999e4e0&scoped=true&"
import script from "./ManageUserGroupsTable.vue?vue&type=script&lang=js&"
export * from "./ManageUserGroupsTable.vue?vue&type=script&lang=js&"
import style0 from "./ManageUserGroupsTable.vue?vue&type=style&index=0&id=f999e4e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f999e4e0",
  null
  
)

export default component.exports